import { uiText, useUiLanguage } from '../../../utils/uiTranslation';
import React from 'react';

const ProfileTopNav = ({ activeTab, onTabChange, tabs, label = 'Settings sections' }) => {
  useUiLanguage();
  const groups = tabs.reduce((result, tab) => {
    const groupId = tab.group || 'settings';
    let group = result.find((item) => item.id === groupId);
    if (!group) {
      group = { id: groupId, label: tab.groupLabel, tabs: [] };
      result.push(group);
    }
    group.tabs.push(tab);
    return result;
  }, []);

  return (
    <div className="profile-top-nav-shell">
      <nav className="profile-top-nav" aria-label={uiText(label)}>
        {groups.map((group) => (
          <div className="profile-nav-group" key={group.id} role="group" aria-labelledby={group.label ? `settings-nav-${group.id}` : undefined}>
            {group.label && <span className="profile-nav-group-label" id={`settings-nav-${group.id}`}>{uiText(group.label)}</span>}
            <div className="profile-nav-group-tabs">
              {group.tabs.map((tab) => (
                <button
                  key={tab.id}
                  type="button"
                  className={`profile-top-tab ${activeTab === tab.id ? 'active' : ''}`}
                  onClick={() => onTabChange(tab.id)}
                  aria-current={activeTab === tab.id ? 'page' : undefined}
                  aria-controls="settings-content"
                  aria-label={uiText(tab.label)}
                  title={uiText(tab.label)}
                >
                  <span className={`profile-top-tab__icon profile-top-tab__icon--${tab.iconTone || 'blue'}`}>
                    <i className={tab.icon} aria-hidden="true"></i>
                  </span>
                  <span className="profile-top-tab__title">{uiText(tab.label)}</span>
                </button>
              ))}
            </div>
          </div>
        ))}
      </nav>
    </div>
  );
};

export default ProfileTopNav;
